import { Icons } from "vuetify/types/services/icons";
import SaveIcon from "@/components/shared/icons/customizable/SaveIcon.vue";
import SettingsIcon from "@/components/shared/icons/customizable/SettingsIcon.vue";
import AccountancyIcon from "@/components/shared/icons/customizable/AccountancyIcon.vue";
import BookingsIcon from "@/components/shared/icons/customizable/BookingsIcon.vue";
import CostDocumentsIcon from "@/components/shared/icons/customizable/CostDocumentsIcon.vue";
import DocumentsIcon from "@/components/shared/icons/customizable/DocumentsIcon.vue";
import FinancesIcon from "@/components/shared/icons/customizable/FinancesIcon.vue";
import OrdersIcon from "@/components/shared/icons/customizable/OrdersIcon.vue";
import ReportsIcon from "@/components/shared/icons/customizable/ReportsIcon.vue";
import UserIcon from "@/components/shared/icons/customizable/UserIcon.vue";
import LogoutIcon from "@/components/shared/icons/customizable/LogoutIcon.vue";
import LockIcon from "@/components/shared/icons/customizable/LockIcon.vue";
import UnlockIcon from "@/components/shared/icons/customizable/UnlockIcon.vue";
import InfoIcon from "@/components/shared/icons/customizable/InfoIcon.vue";
import CheckboxOffIcon from "@/components/shared/icons/customizable/CheckboxOffIcon.vue";
import CheckboxOnIcon from "@/components/shared/icons/customizable/CheckboxOnIcon.vue";
import RadioOffIcon from "@/components/shared/icons/customizable/RadioOffIcon.vue";
import RadioOnIcon from "@/components/shared/icons/customizable/RadioOnIcon.vue";
import ClearIcon from "@/components/shared/icons/customizable/ClearIcon.vue";
import UsersIcon from "@/components/shared/icons/customizable/UsersIcon.vue";
import AddUserIcon from "@/components/shared/icons/customizable/AddUserIcon.vue";
import RemoveUserIcon from "@/components/shared/icons/customizable/RemoveUserIcon.vue";
import ConfirmIcon from "@/components/shared/icons/customizable/ConfirmIcon.vue";
import PaymentsIcon from "@/components/shared/icons/customizable/PaymentsIcon.vue";
import PlusIcon from "@/components/shared/icons/customizable/PlusIcon.vue";
import RefreshIcon from "@/components/shared/icons/customizable/RefreshIcon.vue";
import ArrowUpIcon from "@/components/shared/icons/customizable/ArrowUpIcon.vue";
import ArrowDownIcon from "@/components/shared/icons/customizable/ArrowDownIcon.vue";
import ArrowRightIcon from "@/components/shared/icons/customizable/ArrowRightIcon.vue";
import ArrowDoubleRightIcon from "@/components/shared/icons/customizable/ArrowDoubleRightIcon.vue";
import ArrowLeftIcon from "@/components/shared/icons/customizable/ArrowLeftIcon.vue";
import ArrowDoubleLeftIcon from "@/components/shared/icons/customizable/ArrowDoubleLeftIcon.vue";
import PrintIcon from "@/components/shared/icons/customizable/PrintIcon.vue";
import HistoryIcon from "@/components/shared/icons/customizable/HistoryIcon.vue";
import PersonIcon from "@/components/shared/icons/customizable/PersonIcon.vue";
import EditAttributesIcon from "@/components/shared/icons/customizable/EditAttributesIcon.vue";
import EditIcon from "@/components/shared/icons/customizable/EditIcon.vue";
import RemoveIcon from "@/components/shared/icons/customizable/RemoveIcon.vue";
import CorrectIcon from "@/components/shared/icons/customizable/CorrectIcon.vue";
import NoDocumentToSendIcon from "@/components/shared/icons/documentStatus/NoDocumentToSendIcon.vue";
import NewDocumentIcon from "@/components/shared/icons/documentStatus/NewDocumentIcon.vue";
import DocumentsToAcceptIcon from "@/components/shared/icons/documentStatus/DocumentsToAcceptIcon.vue";
import DocumentsInSendOrderIcon from "@/components/shared/icons/documentStatus/DocumentsInSendOrderIcon.vue";
import OneMailWithLinkIcon from "@/components/shared/icons/documentStatus/OneMailWithLinkIcon.vue";
import OneMailWithAttachmentIcon from "@/components/shared/icons/documentStatus/OneMailWithAttachmentIcon.vue";
import OneMailOpenedByContractorIcon from "@/components/shared/icons/documentStatus/OneMailOpenedByContractorIcon.vue";
import CancelledIcon from "@/components/shared/icons/documentStatus/CancelledIcon.vue";
import ManyMailSenderIcon from "@/components/shared/icons/documentStatus/ManyMailSenderIcon.vue";
import ErrorSendIcon from "@/components/shared/icons/documentStatus/ErrorSendIcon.vue";
import DocumentNonEmptyIcon from "@/components/shared/icons/customizable/DocumentNonEmptyIcon.vue";
import YellowPlusIcon from "@/components/shared/icons/YellowPlusIcon.vue";
import ArrowMoveUpIcon from "@/components/shared/icons/customizable/ArrowMoveUpIcon.vue";
import ArrowMoveDownIcon from "@/components/shared/icons/customizable/ArrowMoveDownIcon.vue";
import RandomIcon from "@/components/shared/icons/customizable/RandomIcon.vue";
import BankIcon from "@/components/shared/icons/customizable/BankIcon.vue";
import FileIcon from "@/components/shared/icons/customizable/FileIcon.vue";
import CalendarIcon from "@/components/shared/icons/customizable/CalendarIcon.vue";
import PreviewIcon from "@/components/shared/icons/customizable/PreviewIcon.vue";
import SearchIcon from "@/components/shared/icons/customizable/SearchIcon.vue";
import DollarInCircleIcon from "@/components/shared/icons/customizable/DollarInCircleIcon.vue";
import ListMenuIcon from "@/components/shared/icons/customizable/ListMenuIcon.vue";
import DocumentPlusIcon from "@/components/shared/icons/customizable/DocumentPlusIcon.vue";
import PairIcon from "@/components/shared/icons/customizable/PairIcon.vue";
import UnpairIcon from "@/components/shared/icons/customizable/UnpairIcon.vue";
import PaymentAddIcon from "@/components/shared/icons/customizable/PaymentAddIcon.vue";
import ContractorsIcon from "@/components/shared/icons/customizable/ContractorsIcon.vue";
import CancelIcon from "@/components/shared/icons/customizable/CancelIcon.vue";
import CashDocumentIcon from "@/components/shared/icons/customizable/CashDocumentIcon.vue";
import ReportIcon from "@/components/shared/icons/customizable/ReportIcon.vue";
import RequestsForPaymentIcon from "@/components/shared/icons/customizable/RequestsForPaymentIcon.vue";
import CreditCardStatementsIcon from "@/components/shared/icons/customizable/CreditCardStatementsIcon.vue";
import BankTransfersIcon from "@/components/shared/icons/customizable/BankTransfersIcon.vue";
import BankTransferOperationsIcon from "@/components/shared/icons/customizable/BankTransferOperationsIcon.vue";
import AdminIconOffices from "@/components/shared/icons/administration/AdminIconOffices.vue";
import ImportIcon from "@/components/shared/icons/customizable/ImportIcon.vue";
import UploadIcon from "@/components/shared/icons/customizable/UploadIcon.vue";
import DateIcon from "@/components/shared/icons/customizable/DateIcon.vue";
import SendIcon from "@/components/shared/icons/customizable/SendIcon.vue";
import AddContractorIcon from "@/components/shared/icons/customizable/AddContractorIcon.vue";
import RemoveContractorIcon from "@/components/shared/icons/customizable/RemoveContractorIcon.vue";
import AddContractorDisabledIcon from "@/components/shared/icons/customizable/AddContractorDisabledIcon.vue";
import RemoveContractorDisabledIcon from "@/components/shared/icons/customizable/RemoveContractorDisabledIcon.vue";
import DuplicateBookingIcon from "@/components/shared/icons/customizable/DuplicateBookingIcon.vue";
import ReturnIcon from "@/components/shared/icons/customizable/ReturnIcon.vue";
import WandIcon from "@/components/shared/icons/customizable/WandIcon.vue";
import PrinterIcon from "@/components/shared/icons/customizable/PrinterIcon.vue";
import CopyIcon from "@/components/shared/icons/customizable/CopyIcon.vue";
import CalcIcon from "@/components/shared/icons/customizable/CalcIcon.vue";
import DialogSuccessIcon from "@/components/shared/icons/customizable/DialogSuccessIcon.vue";
import DialogWarningIcon from "@/components/shared/icons/customizable/DialogWarningIcon.vue";
import DialogErrorIcon from "@/components/shared/icons/customizable/DialogErrorIcon.vue";
import CornerDownRightIcon from "@/components/shared/icons/customizable/CornerDownRightIcon.vue";
import OptionsFilter from "@/components/shared/icons/customizable/OptionsFilter.vue";
import ClipboardIcon from "@/components/shared/icons/customizable/ClipboardIcon.vue";
import GlobeIcon from "@/components/shared/icons/customizable/GlobeIcon.vue";
import BulbIcon from "@/components/shared/icons/customizable/BulbIcon.vue";
import DragHandleIcon from "@/components/shared/icons/customizable/DragHandleIcon.vue";
import CloudUploadIcon from "@/components/shared/icons/customizable/CloudUploadIcon.vue";
import ExclamationIcon from "@/components/shared/icons/customizable/ExclamationIcon.vue";
import MinusCircleIcon from "@/components/shared/icons/customizable/MinusCircleIcon.vue";

export const notificationStatusIcons = {
  noDocuments: {
    component: NoDocumentToSendIcon,
  },
  newDocument: {
    component: NewDocumentIcon,
  },
  documentsToAccept: {
    component: DocumentsToAcceptIcon,
  },
  documentsInSendOrder: {
    component: DocumentsInSendOrderIcon,
  },
  oneMailWithLink: {
    component: OneMailWithLinkIcon,
  },
  oneMailWithAttachment: {
    component: OneMailWithAttachmentIcon,
  },
  oneMailOpenedByContractor: {
    component: OneMailOpenedByContractorIcon,
  },
  cancelled: {
    component: CancelledIcon,
  },
  manyMailSender: {
    component: ManyMailSenderIcon,
  },
  errorSend: {
    component: ErrorSendIcon,
  },
  dialogSuccess: {
    component: DialogSuccessIcon,
  },
  dialogWarning: {
    component: DialogWarningIcon,
  },
  dialogError: {
    component: DialogErrorIcon,
  },
};

export const genericIcons = {
  "yellow-plus": {
    component: YellowPlusIcon,
  },
  dropdown: {
    component: ArrowDownIcon,
  },
  listMenu: {
    component: ListMenuIcon,
  },
  save: {
    component: SaveIcon,
  },
  settings: {
    component: SettingsIcon,
  },
  accountancy: {
    component: AccountancyIcon,
  },
  bookings: {
    component: BookingsIcon,
  },
  costDocuments: {
    component: CostDocumentsIcon,
  },
  cashDocument: {
    component: CashDocumentIcon,
  },
  documents: {
    component: DocumentsIcon,
  },
  documentPlus: {
    component: DocumentPlusIcon,
  },
  documentNonEmpty: {
    component: DocumentNonEmptyIcon,
  },
  finances: {
    component: FinancesIcon,
  },
  orders: {
    component: OrdersIcon,
  },
  report: {
    component: ReportIcon,
  },
  requestsForPayment: {
    component: RequestsForPaymentIcon,
  },
  creditCardStatements: {
    component: CreditCardStatementsIcon,
  },
  bankTransfers: {
    component: BankTransfersIcon,
  },
  bankTransferOperations: {
    component: BankTransferOperationsIcon,
  },
  reports: {
    component: ReportsIcon,
  },
  user: {
    component: UserIcon,
  },
  addUser: {
    component: AddUserIcon,
  },
  removeUser: {
    component: RemoveUserIcon,
  },
  users: {
    component: UsersIcon,
  },
  logout: {
    component: LogoutIcon,
  },
  lock: {
    component: LockIcon,
  },
  unlock: {
    component: UnlockIcon,
  },
  info: {
    component: InfoIcon,
  },
  checkboxOff: {
    component: CheckboxOffIcon,
  },
  checkboxOn: {
    component: CheckboxOnIcon,
  },
  radioOff: {
    component: RadioOffIcon,
  },
  radioOn: {
    component: RadioOnIcon,
  },
  clear: {
    component: ClearIcon,
  },
  confirm: {
    component: ConfirmIcon,
  },
  cancel: {
    component: CancelIcon,
  },
  payments: {
    component: PaymentsIcon,
  },
  paymentAdd: {
    component: PaymentAddIcon,
  },
  plus: {
    component: PlusIcon,
  },
  refresh: {
    component: RefreshIcon,
  },
  arrowUp: {
    component: ArrowUpIcon,
  },
  arrowMoveUp: {
    component: ArrowMoveUpIcon,
  },
  arrowDown: {
    component: ArrowDownIcon,
  },
  arrowMoveDown: {
    component: ArrowMoveDownIcon,
  },
  arrowRight: {
    component: ArrowRightIcon,
  },
  arrowDoubleRight: {
    component: ArrowDoubleRightIcon,
  },
  arrowLeft: {
    component: ArrowLeftIcon,
  },
  arrowDoubleLeft: {
    component: ArrowDoubleLeftIcon,
  },
  print: {
    component: PrintIcon,
  },
  history: {
    component: HistoryIcon,
  },
  person: {
    component: PersonIcon,
  },
  editAttributes: {
    component: EditAttributesIcon,
  },
  edit: {
    component: EditIcon,
  },
  remove: {
    component: RemoveIcon,
  },
  correct: {
    component: CorrectIcon,
  },
  bank: {
    component: BankIcon,
  },
  file: {
    component: FileIcon,
  },
  calendar: {
    component: CalendarIcon,
  },
  preview: {
    component: PreviewIcon,
  },
  search: {
    component: SearchIcon,
  },
  random: {
    component: RandomIcon,
  },
  dollarInCircle: {
    component: DollarInCircleIcon,
  },
  pair: {
    component: PairIcon,
  },
  unpair: {
    component: UnpairIcon,
  },
  contractors: {
    component: ContractorsIcon,
  },
  office: {
    component: AdminIconOffices,
  },
  import: {
    component: ImportIcon,
  },
  upload: {
    component: UploadIcon,
  },
  date: {
    component: DateIcon,
  },
  send: {
    component: SendIcon,
  },
  addContractor: {
    component: AddContractorIcon,
  },
  removeContractor: {
    component: RemoveContractorIcon,
  },
  addContractorDisabled: {
    component: AddContractorDisabledIcon,
  },
  removeContractorDisabled: {
    component: RemoveContractorDisabledIcon,
  },
  return: {
    component: ReturnIcon,
  },
  duplicateBooking: {
    component: DuplicateBookingIcon,
  },
  wand: {
    component: WandIcon,
  },
  printer: {
    component: PrinterIcon,
  },
  copy: {
    component: CopyIcon,
  },
  calc: {
    component: CalcIcon,
  },
  cornerDownRight: {
    component: CornerDownRightIcon,
  },
  filterOptions: {
    component: OptionsFilter,
  },
  clipboard: {
    component: ClipboardIcon,
  },
  globe: {
    component: GlobeIcon,
  },
  bulb: {
    component: BulbIcon,
  },
  dragHandle: {
    component: DragHandleIcon,
  },
  cloudUpload: {
    component: CloudUploadIcon,
  },
  exclamation: {
    component: ExclamationIcon,
  },
  minusCircle: {
    component: MinusCircleIcon,
  },
};

export const iconfont = {
  ...genericIcons,
  ...notificationStatusIcons,
} as Partial<Icons["values"]>;
